import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { contextProvider } from "../SetupPagesContextApi/SetupPagesContextApi";

const SetupDropDown = ({
  placeHolder,
  name,
  valueUpdate,
  allTimeValue,
  dataOf,
  defaultValue
}) => {


  const [data, setData] = useState([]);

  const { companys, branchs, routes, functions, cargoTypes, parcelNumber,boxName,measurementUnit,device,currency,PaymentStatus,itemCategory,dimensions } =
    useContext(contextProvider);

    // static data for some drop down.

    const bookingUserType=["All","Agent"]

    // ..............

  useEffect(() => {
    if (dataOf === "device") setData(device);
    if (dataOf === "measurementUnit") setData(measurementUnit);
    if (dataOf === "company") setData(companys);
    if (dataOf === "route") setData(routes);
    if (dataOf === "function") setData(functions);
    if (dataOf === "cargoName") setData(cargoTypes);
    if (dataOf === "branch") setData(branchs);
    if (dataOf === "parcelNumber") setData(parcelNumber);
    if (dataOf === "bookingUserType") setData(bookingUserType);
    if(dataOf==="boxName") setData(boxName)
    if(dataOf==="currency") setData(currency)
    if(dataOf==="PaymentStatus") setData(PaymentStatus)
    if(dataOf==="itemCategory") setData(itemCategory)
    if(dataOf==="dimension") setData(dimensions)
    
  }, [dataOf, companys, routes, functions, cargoTypes, parcelNumber, branchs,measurementUnit,boxName,itemCategory,dimensions]);


   // placeholder text formate.
   const formateText = (text) => {
    const wordArray = text?.split(" ");
    const formatedWordArray = wordArray?.map((item) => {
      const [firstL, ...rest] = item;
      rest.unshift(firstL.toUpperCase());
      return rest.join("");
    });
    return formatedWordArray?.join(" ")
  };

  return (
    <div className=" w-full ">
      <label className="  font-semibold" htmlFor={placeHolder}>
      {formateText(placeHolder)}
      </label>

      <select
      required
        value={allTimeValue}
        // defaultValue={defaultValue}
        onChange={valueUpdate}
        className={`w-full border border-stone-300 pl-3 pr-9 ${placeHolder&&"mt-1.5"} h-11 outline-none rounded-xl bg-stone-50 focus:bg-white focus:border-orange-500 focus:ring-2 focus:ring-orange-500/15 appearance-none admin-select`}
        id={placeHolder}
        name={name}
      >
        <option className="text-start" value={""} selected hidden  >
          Select one
        </option>
        {data?.map((item, idx) => {
          if (dataOf === "device")
            return (
              <option key={idx} value={item.id}>
                {item.deviceName}{" "}
              </option>
            );
          if (dataOf === "measurementUnit")
            return (
              <option key={idx} value={item.id}>
                {item.unitDescription}{" "}
              </option>
            );
          if (dataOf === "company")
            return (
              <option key={idx} value={item.id}>
                {item.name}{" "}
              </option>
            );
          if (dataOf === "route")
            return (
              <option key={idx} value={item.id}>
                {item.routeName}{" "}
              </option>
            );
          if (dataOf === "cargoName")
            return (
              <option key={idx} value={item.id}>
                {item.cargoTypeName}{" "}
              </option>
            );
          if (dataOf === "function")
            return (
              <option key={idx} value={item.id}>
                {item.cargoTypeName}{" "}
              </option>
            );
          if (dataOf === "parcelNumber")
            return (
              <option key={idx} value={item.barcode}>
                {item.percelNumber}
              </option>
            );
          if (dataOf === "bookingUserType")
            return (
              <option className="text-center" key={idx} value={item}>
                {item}
              </option>
            );
          if (dataOf === "branch")
            return (
              <option key={idx} value={item.id}>
                {item.branchName}
              </option>
            );
          if (dataOf === "boxName")
            return (
              <option key={idx} value={item.id}>
                {item.dimensionName}
              </option>
            );

            if (dataOf === "currency")
              return (
                <option key={idx} value={item.id}>
                  {item.currencyType}
                </option>
              );

              
            if (dataOf === "PaymentStatus")
              return (
                <option key={idx} value={item.id}>
                  {item.statusName}
                </option>
              );

               if (dataOf === "itemCategory")
              return (
                <option key={idx} value={item.id}>
                  {item.name}
                </option>
              );

            if (dataOf === "dimension") {
              // Find measurement unit name
              const measurementUnitName = measurementUnit?.find(
                (unit) => unit.id === item.measurementUnitId
              )?.unitDescription || "";
              
              // Format dimensions to remove unnecessary decimals
              const formatDimension = (value) => {
                if (value == null) return "";
                const num = parseFloat(value);
                return num % 1 === 0 ? num.toString() : num.toFixed(2);
              };
              
              return (
                <option key={idx} value={item.id}>
                  {item.dimensionName} ({formatDimension(item.length)} x {formatDimension(item.width)} x {formatDimension(item.height)}) {measurementUnitName}
                </option>
              );
            }
        })}

        
      </select>
    </div>
  );
};

export default SetupDropDown;
